<script>
    import Scene from "./Scene.svelte";
    import Grid from "../pre-comps/Grid.svelte";
    import Spotlight from "../pre-comps/SpotlightScene.svelte";

    const layers = [
        Grid,
        Spotlight,
    ];

</script>

<Scene layers={layers}></Scene>